import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "source",
  class: "form-label"
}, "Native Language", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "my-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "source",
  class: "form-label"
}, "Target Language", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "my-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-secondary"
  }, "Submit")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tile = _resolveComponent("Tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tile, { title: "Language Selection" }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectLanguage && _ctx.selectLanguage(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "data-bs-theme": "dark",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.source) = $event)),
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: idx,
                  value: language.code
                }, _toDisplayString(language.name), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.source]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "data-bs-theme": "dark",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.target) = $event)),
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: idx,
                  value: language.code
                }, _toDisplayString(language.name), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.target]
            ])
          ]),
          _hoisted_8
        ], 32)
      ]),
      _: 1
    })
  ]))
}